import useAnimationControls from '@shared/hooks/useAnimationControls';
import styles from './AnimationControl.module.scss';
import ImageIcon from './ImageIcon';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

const INTERACTION_VISIBILITY_DURATION_MILLISECONDS = 3000;

export default function AnimationControl() {
  const { isPaused, toggle } = useAnimationControls();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timeoutId: number | undefined;
    function showTemporarily() {
      setIsVisible(true);
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(
        () => setIsVisible(false),
        INTERACTION_VISIBILITY_DURATION_MILLISECONDS,
      );
    }

    window.addEventListener('pointermove', showTemporarily);
    window.addEventListener('pointerdown', showTemporarily);

    return () => {
      window.clearTimeout(timeoutId);
      window.removeEventListener('pointermove', showTemporarily);
      window.removeEventListener('pointerdown', showTemporarily);
    };
  }, []);

  return (
    <button
      type="button"
      className={classNames(
        styles['animation-control'],
        isPaused && [styles['animation-control--paused']],
        isVisible && [styles['animation-control--visible']],
      )}
      onClick={toggle}
      aria-pressed={isPaused}
    >
      <ImageIcon
        type={isPaused ? 'play' : 'pause'}
        className={styles.icon}
        alt=""
      />
      <span className={styles.label}>
        {isPaused ? 'Fortsätt visning' : 'Pausa rörligt innehåll'}
      </span>
    </button>
  );
}
